// 募集を探すのSP画面で、4番目のカードの後ろにトップバナー、7番目のカードの後ろにボトムバナーを表示するための関数。
export function getBannerPositionsInRecruitInfoForSp(
  index: number,
): 'top' | 'bottom' | undefined {
  const topBannerPosition = 4;
  const bottomBannerPosition = 8;
  const positions: Record<number, 'top' | 'bottom'> = {
    [topBannerPosition]: 'top',
    [bottomBannerPosition]: 'bottom',
  };
  return positions[index] ?? undefined;
}
